export default __webpack_public_path__ + "static/8-order-chat-39f5ef4dee2912be36eed17e6d812287.png";